module.exports = __webpack_public_path__ + "img/intercomdescribe2.07148c47.png";